<template>
  <div class="link-apps flex justify-center q-gutter-8">
    <a
      v-for="key in buttons"
      :key="key"
      class="block"
      :href="appLinks[key]"
      @click="$emit('click', key)"
    >
      <q-img
        :class="{
          'increase-img-size': increaseImgSize,
        }"
        :src="links[key]"
        width="141px"
        height="42px"
        spinner-size="42px"
      />
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useQuasar } from 'quasar';

import useAppLinks from '~composables/useAppLinks';
import { useConfigsStore } from '~stores/configs';

defineEmits(['click']);

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  isPlatformSpecific: {
    type: Boolean,
    default: false,
  },
  increaseImgSize: {
    type: Boolean,
    default: false,
  },
});

const { platform } = useQuasar();
const { locale } = useI18n();
const { appLinks } = useAppLinks(props.type);
const configsStore = useConfigsStore();

const { configs } = storeToRefs(configsStore);

const links = computed(() => {
  const baseUrl = `${configs.value.base_url}/img/localized/${locale.value}`;
  return {
    ios: `${baseUrl}/apple.png`,
    android: `${baseUrl}/google-play.png`,
    huawei: `${baseUrl}/huawei.png`,
  };
});

const platforms = computed(() => {
  if (!props.isPlatformSpecific || !platform.is.mobile) return ['ios', 'android', 'huawei'];

  if (platform.is.ios) return ['ios'];

  return ['android', 'huawei'];
});

const buttons = computed(() => platforms.value.filter((el) => appLinks[el]));
</script>

<style lang="scss" scoped>
@media screen and (max-width: $breakpoint-xs-max) {
  .increase-img-size {
    height: 56px !important;
    width: 189px !important;
  }
}
</style>
